import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=b1e4b5bc&lang=pug"
import script from "./ProfilePage.vue?vue&type=script&lang=js"
export * from "./ProfilePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1e4b5bc')) {
      api.createRecord('b1e4b5bc', component.options)
    } else {
      api.reload('b1e4b5bc', component.options)
    }
    module.hot.accept("./ProfilePage.vue?vue&type=template&id=b1e4b5bc&lang=pug", function () {
      api.rerender('b1e4b5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/user_profiles/ProfilePage.vue"
export default component.exports